import {
  Listings_Detail as ListingCate,
  ListingsByFilterQuery as CateListingsByFilterQuery,
} from '@/types/cate-graphql-generated-types'

import { Poi } from './poi'

export type Listing = Omit<ListingCate, 'pointsOfInterest' | 'relevance'> & {
  pointsOfInterest: Poi[]
}

export type Listings = Listing[]
export type PickListing<K extends keyof Listing> = Pick<ListingCate, K>


export enum CasavoInventory {
  Agency = 'oda',
  Priority = 'priority',
  Third_Party = 'third_party',
  iBuyer = 'ibuyer',
}
